import { render, staticRenderFns } from "./AtomsTitle.vue?vue&type=template&id=925784f2&scoped=true&"
import script from "./AtomsTitle.vue?vue&type=script&lang=js&"
export * from "./AtomsTitle.vue?vue&type=script&lang=js&"
import style0 from "./AtomsTitle.vue?vue&type=style&index=0&id=925784f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925784f2",
  null
  
)

export default component.exports